import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

const ScrollToError: React.FC<{}> = (props) => {
  const { errors } = useFormikContext();

  useEffect(() => {
    const el = document.querySelector('.form-errors');
    const scrollToElement = (el?.parentElement ?? el);

    if (scrollToElement) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [errors]);

  return null;
}

export default ScrollToError
